import {jwtDecode} from 'jwt-decode';

// Check if the token is expired
export const isTokenExpired = () => {
  const token = localStorage.getItem('jwt_token_jobcritic');
  if (!token) return true; // No token means session is invalid

  try {
    const decoded = jwtDecode(token); // Decode JWT
    const currentTime = Date.now() / 1000; // Current time in seconds
    console.log("----exp---",decoded,currentTime);
    return decoded.exp < currentTime; // True if token is expired
  } catch (error) {
    console.error('Invalid token:', error);
    return true; // Treat invalid tokens as expired
  }
};

// Logout function
export const logout = () => {
  localStorage.removeItem('jwt_token_jobcritic');
  localStorage.clear();
  // Redirect to login page
  window.location.href = '/';
};